var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.computedOriginList, function(item) {
              return _c(
                "div",
                {
                  key: item.origin_id,
                  staticClass: "status",
                  class: { active: _vm.origin === item.origin_id },
                  on: {
                    click: function($event) {
                      return _vm.selectOrigin(item.origin_id)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(item.origin_name) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: _vm.search_type,
                                      callback: function($$v) {
                                        _vm.search_type = $$v
                                      },
                                      expression: "search_type"
                                    }
                                  },
                                  _vm._l(_vm.search_options, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.name,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-left": "-15px",
                                  width: "165px"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入搜索内容" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.search_value,
                                    callback: function($$v) {
                                      _vm.search_value = $$v
                                    },
                                    expression: "search_value"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "理赔类型" },
                                    on: { change: _vm.setType },
                                    model: {
                                      value: _vm.form.f_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "f_type", $$v)
                                      },
                                      expression: "form.f_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.computedClaimTypes, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.claims_type_id,
                                        attrs: {
                                          label: item.title,
                                          value: item.claims_type_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "理赔二级类型" },
                                    model: {
                                      value: _vm.form.type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "type", $$v)
                                      },
                                      expression: "form.type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.types, function(item) {
                                      return _c("el-option", {
                                        key: item.claims_type_id,
                                        attrs: {
                                          label: item.title,
                                          value: item.claims_type_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "是否拆包" },
                                    model: {
                                      value: _vm.form.cb_status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "cb_status", $$v)
                                      },
                                      expression: "form.cb_status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.cb_options2, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.name,
                                          value: item.key
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "是否实物拆包" },
                                    model: {
                                      value: _vm.form.cb_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "cb_type", $$v)
                                      },
                                      expression: "form.cb_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.cb_options, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.name,
                                          value: item.key
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "登记时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "客服备注" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.service_desc,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "service_desc", $$v)
                                    },
                                    expression: "form.service_desc"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退款时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.refund_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "refund_time", $$v)
                                    },
                                    expression: "form.refund_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "问题类型" },
                                    on: { change: _vm.setProblem },
                                    model: {
                                      value: _vm.form.problem_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "problem_id", $$v)
                                      },
                                      expression: "form.problem_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.computedIssueTypes, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.problem_id,
                                        attrs: {
                                          label: item.problem_name,
                                          value: item.problem_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "问题描述" },
                                    model: {
                                      value: _vm.form.second_problem_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "second_problem_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.second_problem_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.problems, function(item) {
                                      return _c("el-option", {
                                        key: item.problem_id,
                                        attrs: {
                                          label: item.problem_name,
                                          value: item.problem_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "处理状态" },
                                    model: {
                                      value: _vm.form.handle_status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "handle_status", $$v)
                                      },
                                      expression: "form.handle_status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.resData.handle_status, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.label,
                                          value: item.key
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "理赔状态" },
                                    model: {
                                      value: _vm.form.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "status", $$v)
                                      },
                                      expression: "form.status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.status_options, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.name,
                                          value: item.key
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "拆包时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.back_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "back_time", $$v)
                                    },
                                    expression: "form.back_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "申请时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.apply_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "apply_time", $$v)
                                    },
                                    expression: "form.apply_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "160px" },
                                    attrs: { placeholder: "是否超时自动退款" },
                                    model: {
                                      value: _vm.form.is_back_over_refund,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "is_back_over_refund",
                                          $$v
                                        )
                                      },
                                      expression: "form.is_back_over_refund"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "是", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "否", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { slot: "trigger", size: "mini", type: "primary" },
                    on: { click: _vm.openSplit },
                    slot: "trigger"
                  },
                  [_vm._v("拆工单理赔")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { slot: "trigger", size: "mini", type: "primary" },
                    on: { click: _vm.openClaims },
                    slot: "trigger"
                  },
                  [_vm._v("申请理赔")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.exportExcel }
                  },
                  [_vm._v("\n          导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addColor
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            type: "selection",
                            width: "55"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "work_id",
                            label: "工单ID"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "back_shipping_num",
                            label: "用户寄回运单号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_nums",
                            label: "仓库拆包寄回运单号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "add_time",
                            label: "登记时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "商品图片" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.imgs.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "70px"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: scope.row.imgs[0] },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showImages(
                                                    scope.row.imgs
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2128690515
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            "show-overflow-tooltip": "",
                            prop: "goods_name",
                            label: "商品名称",
                            width: "150"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_no",
                            label: "商品货号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "颜色/尺码/件数" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.co_val) +
                                        "/ " +
                                        _vm._s(scope.row.si_val) +
                                        "/\n              " +
                                        _vm._s(scope.row.goods_number) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2569554805
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", prop: "sku", label: "sku" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "refund_goods_money",
                            label: "商品金额"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "refund_money",
                            label: "退款金额"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "adopt_refund_time",
                            label: "退款时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "handle_user",
                            label: "发布人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "service_order_handle_status",
                            label: "处理状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "problem_type",
                            label: "问题类型"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "problem_name",
                            label: "问题描述"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "service_desc",
                            label: "客服备注"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "back_time",
                            label: "拆包时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "is_back_over_refund",
                            label: "是否超时自动退款"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.is_back_over_refund === "1"
                                      ? _c("div", [_vm._v("是")])
                                      : _c("div", [_vm._v("否")])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3845499127
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "back_admin",
                            label: "拆包人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "dbids",
                            label: "有实物打标id"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "no_back_num",
                            label: "无实物件数"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "back_remark",
                            label: "拆包备注"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "claims_detail_back_status",
                            label: "拆包状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "claims_detail_status",
                            label: "理赔状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "check_remark",
                            label: "审核备注"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "申请时间/申请人"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.create_time) +
                                        "/\n              " +
                                        _vm._s(scope.row.apply_admin) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3227862919
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "理赔类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.f_claims_type) +
                                        "/\n              " +
                                        _vm._s(scope.row.claims_type) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1873936148
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "",
                            label: "计费方式/计费比例/商品理赔"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row.claims_billing_method
                                        ) +
                                        "/\n              " +
                                        _vm._s(scope.row.billing_rate) +
                                        "/" +
                                        _vm._s(scope.row.money) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2261850564
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "dbid",
                            label: "操作",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status == 0 ||
                                    scope.row.status == 3
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDetail(
                                                      scope.row.work_id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("拆包")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.status == 1 ||
                                    scope.row.status == 2
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDetail(
                                                      scope.row.work_id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("查看")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1563609661
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ,sizes",
                        total: _vm.resData.count,
                        "page-size": _vm.form.pagesize,
                        "page-sizes": [50, 100, 200, 500, 1000]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShow
        ? _c(
            "div",
            [
              _c("UnPackage", {
                attrs: { "work-id": _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isClaimsVisible
        ? _c(
            "div",
            [
              _c("Claims", {
                attrs: {
                  "work-ids": _vm.multipleSelection,
                  "claims-detail-id": _vm.claims_detail_id,
                  origin: _vm.origin
                },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.is_Split
        ? _c(
            "div",
            [
              _c("Split", {
                attrs: { claims_detail_id: _vm.claims_detail_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.images, show: _vm.showbox },
        on: {
          closeBox: function($event) {
            return _vm.closeBox()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf45ac44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf45ac44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims/Index.vue
// module id = null
// module chunks = 